import Button from 'react-bootstrap/Button'
import BSCard from 'react-bootstrap/Card'
import Dropdown from 'react-bootstrap/Dropdown'
import DropdownButton from 'react-bootstrap/DropdownButton'

import OutboundLink from '@/components/OutboundLink/OutboundLink'
import toastService from '@/services/toast.service'
import { CommanderPageProps } from '@/types/page'
import { tcgplayerLink } from '@/utils/helpers'

import styles from './DecklistPanel.module.scss'

type Props = {
  data: CommanderPageProps['data']
}

const DecklistPanel = ({ data }: Props) => {
  const { archidekt, deck } = data

  if (!deck) {
    return null
  }

  const copyToClipboard = () => {
    navigator.clipboard.writeText(deck.join('\r\n'))
    toastService.createToast('Copied to clipboard!')
  }

  const archidektDeckbuilderUrl =
    archidekt && `https://archidekt.com/sandbox?deck=${encodeURI(JSON.stringify(archidekt))}`

  const archidektPlaytesterUrl =
    archidekt && `https://archidekt.com/playtester-v2/sandbox?deck=${encodeURI(JSON.stringify(archidekt))}`

  const moxfieldUrl = deck && `https://www.moxfield.com/import?c=${encodeURI(deck.join('\n'))}`

  const cardkingdomQueries = new URLSearchParams({
    c: deck.join('\r\n'),
    partner: 'edhrec',
    utm_campaign: 'edhrec',
    utm_medium: 'avgdeck',
    utm_source: 'edhrec',
  })
  const cardkingdomUrl = 'https://www.cardkingdom.com/builder?' + cardkingdomQueries.toString()

  const tcgpParams = new URLSearchParams({
    c: deck.join('||'),
    partner: 'EDHREC',
    utm_campaign: 'affiliate',
    utm_medium: 'avgdeck',
    utm_source: 'EDHREC',
  })
  const tcgplayerUrl = tcgplayerLink({
    subId1: 'decklist',
    u: 'https://store.tcgplayer.com/massentry?' + tcgpParams.toString(),
  })

  return (
    <div className='d-flex justify-content-center p-2 w-100'>
      <div className='d-flex flex-column w-100'>
        <div className='d-flex flex-row justify-content-between mb-2'>
          <div className='d-flex gap-2 me-2'>
            <DropdownButton size='sm' title='Export' variant='secondary'>
              <Dropdown.Item href={archidektDeckbuilderUrl} target='_blank'>
                Archidekt
              </Dropdown.Item>
              <Dropdown.Item href={moxfieldUrl} target='_blank'>
                Moxfield
              </Dropdown.Item>
              <Dropdown.Item onClick={copyToClipboard} target='_blank'>
                Plaintext
              </Dropdown.Item>
            </DropdownButton>
          </div>
          <Button className={styles.archidekt} href={archidektPlaytesterUrl} size='sm' target='_blank'>
            <div className={'d-flex flex-row'}>
              <span>Playtest</span>
              <span className='d-none d-md-block'>&nbsp;on Archidekt</span>
            </div>
          </Button>
          <div className='d-flex gap-2'>
            {cardkingdomUrl && (
              <OutboundLink className='btn btn-secondary btn-sm' url={cardkingdomUrl}>
                <div className='d-flex flex-row'>
                  <span className='d-none d-md-block'>Buy at&nbsp;</span>
                  <span>Card Kingdom</span>
                </div>
              </OutboundLink>
            )}
            {tcgplayerUrl && (
              <OutboundLink className='btn btn-secondary btn-sm' url={tcgplayerUrl}>
                <div className='d-flex flex-row'>
                  <span className='d-none d-md-block'>Buy at&nbsp;</span>
                  <span>TCGPlayer</span>
                </div>
              </OutboundLink>
            )}
          </div>
        </div>
        <BSCard className={styles.card}>
          <BSCard.Body className={styles.code}>
            <div>
              <code>{deck.join('\n')}</code>
            </div>
          </BSCard.Body>
        </BSCard>
      </div>
    </div>
  )
}

export default DecklistPanel
